import type { ComponentPropsWithoutRef } from 'react'

const ModalListWrapper = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div className={`absolute top-17 bottom-21 left-0 w-full px-5 pb-5 ${className}`} {...props} />
)

export default ModalListWrapper
